import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Crown, Trophy } from 'lucide-react'
import { modeIcon, modeLabel } from '../utils/teamStats'
import { accentColor, TEAM_THEME } from '../utils/teamColors'
import { hapticImpact } from '../../../utils/haptic'

const TeamHonors = ({ team, chipStyle }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const capture = Array.isArray(team?.capture) ? team.capture : []
  const places = Array.isArray(team?.top_places) ? team.top_places : []
  if (!capture.length && !places.length) return null

  const accent = accentColor(team.colors)
  const style = chipStyle || {
    color: TEAM_THEME.text,
    backgroundColor: `${TEAM_THEME.text}0D`,
    borderColor: `${TEAM_THEME.text}1F`
  }
  const chipClass = 'inline-flex items-center gap-1 rounded-full border px-2 py-1 text-[11px] font-semibold active:scale-[0.98]'

  const open = (event, path) => {
    event.stopPropagation()
    hapticImpact('light')
    navigate(path)
  }

  return <div className="flex flex-wrap gap-1.5">
    {capture.map((entry) => {
      const Icon = modeIcon(entry.mode)
      const isThreat = entry.status === 'threat'
      const iconStyle = { color: isThreat ? '#FF4B4B' : accent }
      return <button key={entry.mode} type="button" onClick={(event) => open(event, `/teams/capture/${entry.mode}`)} className={chipClass} style={isThreat ? { ...style, borderColor: '#FF4B4B66' } : style} title={t('team.capture.ownedMode', { mode: modeLabel(entry.mode, t) })}><Crown size={12} style={iconStyle} /><Icon size={12} style={iconStyle} />{modeLabel(entry.mode, t)}</button>
    })}
    {places.map((entry) => <button key={entry.mode} type="button" onClick={(event) => open(event, '/teams/top')} className={chipClass} style={style} title={t('team.capture.topPlace', { place: entry.place, mode: modeLabel(entry.mode, t) })}><Trophy size={12} style={{ color: accent }} />{t('team.capture.topPlace', { place: entry.place, mode: modeLabel(entry.mode, t) })}</button>)}
  </div>
}

export default TeamHonors
